import React from 'react';
import { Row, Col, Collapse } from 'antd';
import { UnpaidFeeResultLineTextForm } from './../';

class UnpaidFeeMultipleResultForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
    };
  }

  /**
   * Timer to animate unpaid fee results. Makes the lines visible 1 by 1 (fast)
   */
  componentWillMount() {
    let form = this;
    setTimeout(function () {
      form.show();
    }, form.props.wait);
  }

  /**
   * Shows a unpaid fee result when called.
   */
  show() {
    this.setState({ hidden: true });
  }

  /**
   * Creates a unpaid fee result line
   * @returns {*}
   */
  createNameElement = () => {
    if (this.props.unpaidFee.get('Firstname') != null) {
      return (
        <UnpaidFeeResultLineTextForm
          text={'Navn:'}
          value={`${this.props.unpaidFee.get('Firstname')} ${this.props.unpaidFee.get('Lastname')}`}
        />
      );
    } else if (this.props.unpaidFee.get('Lastname') != null) {
      return (
        <UnpaidFeeResultLineTextForm
          text={'Virksomhed:'}
          value={this.props.unpaidFee.get('Lastname')}
        />
      );
    } else {
      return null;
    }
  };

  render() {
    return this.state.hidden ? (
      <Row>
        <Col span={24}>
          <Collapse className={`search-result-card-${this.props.colorCode}`}>
            <Collapse.Panel header={this.props.cardTitle}>
              <div>
                {this.props.unpaidFee.get('Text') ? (
                  <Row>
                    <Col span={24}>
                      <div className={'result-card-body'}>{this.props.unpaidFee.get('Text')}</div>
                    </Col>
                  </Row>
                ) : null}
                {this.props.unpaidFee.get('AKRnumber') ? (
                  <UnpaidFeeResultLineTextForm
                    text={'AKR:'}
                    value={this.props.unpaidFee.get('AKRnumber')}
                  />
                ) : null}
                {this.props.unpaidFee.get('CPRnumber') ? (
                  <UnpaidFeeResultLineTextForm
                    text={'CPR:'}
                    value={this.props.unpaidFee.get('CPRnumber')}
                  />
                ) : null}
                {this.props.unpaidFee.get('CVRnumber') ? (
                  <UnpaidFeeResultLineTextForm
                    text={'CVR:'}
                    value={this.props.unpaidFee.get('CVRnumber')}
                  />
                ) : null}
                {this.createNameElement()}
              </div>
            </Collapse.Panel>
          </Collapse>
        </Col>
      </Row>
    ) : null;
  }
}

export default UnpaidFeeMultipleResultForm;
